const COOKIES = {
	POS: {
		AUTH: "cookie_pos",
	},
};

export default COOKIES;
